export default __webpack_public_path__ + "static/media/chevron.3740ceeb.svg";